import type { Locale } from './en';

const zh: Locale = {
  meta: { code: 'ZH', label: '中文', dir: 'ltr' },
  nav: {
    howItWorks: '使用指南',
    fees: '费率',
    coins: '币种',
    faq: '常见问题',
    about: '关于',
    pepetual: 'Pepetual',
    support: '客服',
    launchApp: '开始兑换',
    marketsOpen: '市场开放中',
  },
  ticker: { liveMarkets: '实时行情' },
  home: {
    heroEyebrow: '无 KYC · 非托管 · 900+ 币种',
    heroTitlePre: '兑换加密货币',
    heroTitleMid: '如同',
    heroTitleAccent: '市场',
    heroTitlePost: '在注视。',
    heroLead:
      '900+ 加密货币的实时市场汇率。无需账户、无需身份核验、无需托管。你发送，网络兑换，你的钱包接收——通常 30 分钟内到账。',
    exchangeOperatorHeading: '兑换运营方',
    exchangeOperatorNote: 'ChangeNOW 是我们的流动性合作方，并负责运营所有兑换。如有交易问题，请联系 ChangeNOW 客服并提供状态页面显示的 TXID。',
    transactionSupportCta: '联系 ChangeNOW 客服',
    startSwapping: '开始兑换',
    howItWorks: '使用指南',
    heroStats: { coins: '币种', avgSettle: '平均到账', kyc: 'KYC', liveRates: '实时汇率' },
    marketsEyebrow: '市场',
    marketsTitle: '热门兑换对',
    marketsDesc:
      '直达 ShieldMyAss 上交易量最高的路线。每个兑换对都会预配置好兑换组件，让你数秒内即可兑换。',
    processEyebrow: '流程',
    processTitle: '三步搞定，仅此而已。',
    processDesc: '无需账户、无需充值、无需 API 密钥。就是一次兑换。',
    assetsEyebrow: '资产',
    assetsTitle: '引领市场的币种',
    assetsDesc: '主流币、隐私币、稳定币与代币化商品的深度流动性。',
    whyEyebrow: '为何选择 ShieldMyAss',
    whyTitle: '为重视隐私的人而生。',
    whyDesc: '每一个设计决策都始于同一个问题：如何让这笔交易尽可能私密、快速与公平？',
    questionsEyebrow: '问答',
    questionsTitle: '好问题，诚实的回答。',
    seeAllFaqs: '查看全部问答',
  },
  steps: [
    { title: '选择兑换对', text: '从 900+ 币种中挑选。比特币到门罗币、ETH 到 USDT——选择你发送的和想接收的。' },
    { title: '输入地址', text: '粘贴接收币种的钱包地址。我们会按目标网络校验地址格式。' },
    { title: '发送、安心、接收', text: '将存款发送到生成的地址。实时追踪每个步骤，直到币种到账你的钱包。' },
  ],
  trustPoints: [
    { icon: 'shield', title: '永远无 KYC', text: '无需身份核验、邮箱或账户即可兑换。' },
    { icon: 'lock', title: '非托管', text: '资金直接从你的钱包到你的钱包。' },
    { icon: 'bolt', title: '5–30 分钟到账', text: '每笔交易都有实时状态追踪。' },
    { icon: 'globe', title: '900+ 币种', text: '从比特币到门罗币，从稳定币到黄金代币。' },
  ],
  stats: [
    { num: '900', unit: '+', label: '支持币种' },
    { num: '30', unit: '+', label: '区块链' },
    { num: '5', unit: '分钟', label: '平均到账' },
    { num: '0', unit: '%', label: '需要 KYC' },
  ],
  cta: {
    eyebrow: '随时待命',
    titleA: '数分钟内完成兑换。',
    titleB: '无需账户，无需 KYC。',
    desc: '选择兑换对，粘贴地址，剩下的交给网络。你的币种直接进入你的钱包——绝不由我们持有。',
    startSwapping: '开始兑换',
    browseCoins: '浏览币种',
  },
  footer: {
    brandDesc:
      '一个无 KYC、非托管的加密货币兑换平台。以实时市场汇率兑换 900+ 币种——你的密钥、你的币、你的事。',
    allSystemsOperational: '所有系统运行正常',
    colProduct: '产品',
    colPairs: '热门兑换对',
    colCompany: '公司',
    feesRates: '费率与汇率',
    supportedCoins: '支持的币种',
    launchExchange: '打开兑换',
    disclaimer:
      'ShieldMyAss 是非托管兑换服务。加密货币交易风险显著。价格波动剧烈，过往表现不代表未来收益。发送资金前请务必核对存款地址与网络。ChangeNOW 是我们的流动性合作方，并负责运营所有兑换。',
    copyright: '保留所有权利。',
  },
  exchange: {
    instantSwap: '即时兑换 · 无 KYC',
    transactionLive: '交易进行中',
    youSend: '你发送',
    youReceive: '你接收',
    estimated: '预估',
    min: '最低：{amount} {ticker}',
    destinationAddress: '接收地址',
    addressValid: '地址看起来有效',
    enterAmount: '输入金额以查看实时汇率。',
    fetchingRate: '正在获取实时汇率…',
    increaseAmount: '请增加金额（最低 {amount} {ticker}）',
    exchangeNow: '立即兑换',
    creatingSwap: '正在创建兑换…',
    nonCustodialNote: '非托管 · 资金直接进入你的钱包',
    poweredBy: '所有兑换均由 ChangeNOW 运营',
    newExchange: '新建兑换',
    invalidAddress: '接收地址似乎无效，请核对后重试。',
    minAmountError: '该兑换对的最低金额为 {amount} {ticker}。',
    createError: '无法创建交易，请重试。',
    pickerTitleFrom: '你发送',
    pickerTitleTo: '你接收',
    pickerSub: '选择一种加密货币',
    pickerPopular: '热门',
    pickerAll: '全部资产',
    pickerSearch: '按名称、代码或网络搜索…',
    pickerEmpty: '没有匹配“{query}”的币种。',
    pickerFooter: '{count} 个资产 · 数据来自流动性网络',
  },
  pages: {
    howItWorks: {
      eyebrow: '流程',
      title: '从发送到接收，五个步骤。',
      lead: '无需账户、无需充值、无需 API 密钥。从任意钱包到任意钱包的干净兑换，通常三十分钟内完成。',
      detail: [
        { title: '选择兑换对', body: '选择你要发送的币种和想接收的币种。我们支持 30+ 区块链上超过 900 种资产，热门兑换对置顶于每个列表。', points: ['BTC、ETH、SOL、XMR 及所有主流 L1', '5+ 网络上的 USDT 与 USDC', '代币化黄金（XAUT）与稳定币'] },
        { title: '输入金额', body: '输入你要发送的金额。组件会立即向合作流动性网络查询实时汇率，并在你确认前显示确切的接收金额。', points: ['汇率每 10 秒刷新', '网络最低额实时显示', '标准规模交易无滑点'] },
        { title: '粘贴接收地址', body: '输入你想接收目标币种的钱包地址。我们会按目标网络做格式校验，让笔误在资金之前被发现。', points: ['按网络逐一校验地址', '无需邮箱、电话、账户', '地址是我们接触的唯一个人信息'] },
        { title: '发送存款', body: '为你的交易生成一次性存款地址。从任意钱包——硬件、移动、桌面或交易所——向其发送确切金额。存款窗口开启足够久，慢网络也不怕。', points: ['每笔交易独立存款地址', '为移动钱包提供二维码', '只发送你选择的币种'] },
        { title: '追踪每个阶段', body: '状态页自动更新。你实时看到存款确认、兑换执行和出账广播。无需刷新按钮——不过我们仍提供了一个。', points: ['五阶段进度条', '实时入账与出账哈希', '每 10 秒自动刷新'] },
      ],
      faqEyebrow: '问答',
      faqTitle: '兑换前大家会问的问题',
    },
    fees: {
      eyebrow: '定价',
      title: '所见即所得的汇率。',
      lead: '无服务费、无提现费、无订阅。唯一成本是合作流动性方嵌入实时汇率中的微小点差。',
      zeroTitle: '零隐藏费用',
      zeroDesc: '下方所有信息都会在你确认交易前显示在组件中。',
      tableHeaders: ['项目', '费用', '含义'],
      rows: [
        { label: '服务费', value: '0%', note: '我们在网络汇率之上不加收任何费用。' },
        { label: '网络点差', value: '0.25–0.9%', note: '由流动性合作方嵌入汇率中。' },
        { label: '最低交易', value: '约 $2', note: '按兑换对设定，组件中实时可见。' },
        { label: '最高交易', value: '无硬性上限', note: '大额交易可能拆分以保护汇率。' },
        { label: '托管费', value: '0%', note: '我们从不持有你的资金，故无所收费。' },
        { label: '账户费', value: '0%', note: '没有账户。' },
      ],
      includedEyebrow: '包含哪些',
      includedTitle: '你无需担心的事',
      included: [
        '组件中报出的汇率即你得到的汇率。',
        '网络最低额实时显示——交易中途无意外。',
        '无需充值、无提现上限、无阶梯定价。',
        '超大额交易可能自动跨流动性场所路由以最小化滑点。',
      ],
    },
    about: {
      eyebrow: '关于',
      title: '我们只想要一个尊重用户的兑换。',
      lead: 'ShieldMyAss 的存在，是因为其他每个兑换平台都想在让我们转 50 美元门罗币前看护照。我们认为这不对，于是打造了替代方案。',
      valuesEyebrow: '价值观',
      valuesTitle: '四条原则，没有例外。',
      values: [
        { icon: 'eye', title: '默认隐私', text: '无 KYC、无邮箱、无追踪。你的接收地址是我们唯一能见的信息，交易完成即遗忘。' },
        { icon: 'lock', title: '非托管', text: '我们从不持有你的币。资金通过一次存款地址经网络兑换直接进入你的钱包。不存在可被黑客盗取的 ShieldMyAss 余额。' },
        { icon: 'bolt', title: '速度即功能', text: '我们为延迟着迷——从 10 秒刷新汇率到状态页自动更新。兑换就该像兑换，而不是一份表单。' },
        { icon: 'feather', title: '极简主义', text: '一个页面，一件事。我们剥除一切与交易无关的东西。没有你没要的图表、没有追加销售、没有代币。' },
      ],
      storyEyebrow: '故事',
      storyTitle: '我们如何走到今天',
      timeline: [
        { year: '我们为何存在', text: 'ShieldMyAss 由厌倦了兑换平台为 50 美元交易索要身份文件的人创建。我们想要一个尊重加密货币最初赛博朋克承诺的工具：私密、点对点、不可逆。' },
        { year: '我们如何运作', text: 'ChangeNOW 是我们的流动性合作方，并负责运营所有兑换。ShieldMyAss 提供兑换界面和实时交易状态。报价中包含少量点差，我们绝不出售你的数据。' },
        { year: '我们不做的事', text: '我们永远不会为标准兑换要求身份文件，永远不会托管你的资金，也永远不会发币来“奖励”用户。若情况改变，我们会在首页告知。' },
      ],
    },
    contact: {
      eyebrow: '联系',
      title: '兑换遇到问题？',
      lead: '有关交易状态、延迟、退款或其他兑换问题，请直接联系 ChangeNOW 客服，并提供状态页面显示的 TXID。网站问题请通过下方邮箱联系我们。',
      transactionSupportEyebrow: '交易支持',
      transactionSupportTitle: '所有兑换均由 ChangeNOW 运营',
      transactionSupportDesc: 'ShieldMyAss 使用 ChangeNOW 作为流动性合作方，所有兑换均由 ChangeNOW 运营。ChangeNOW 客服可查询你的交易，请提供状态页面显示的完整 TXID。',
      transactionSupportCta: '联系 ChangeNOW 客服',
      support: '网站支持',
      email: '邮箱',
      beforeTitle: '联系网站支持前',
      before: [
        '如需查询交易状态、延迟或退款，请通过上方链接联系 ChangeNOW 并提供完整 TXID。',
        '如有网站相关问题，请发送邮件联系我们。',
        '请勿向任何人透露钱包助记词或私钥。',
        '网站支持邮件会在 24 小时内回复，欧洲工作时段通常更快。',
      ],
      securityTitle: '安全报告',
      securityDesc: '发现漏洞？请以“SECURITY”为标题邮件联系我们。我们快速响应并致谢负责任的披露。',
    },
    faq: {
      eyebrow: '帮助',
      title: '常见问题。',
      lead: '兑换前、中、后你可能想知道的一切。',
      transactionSupportEyebrow: '交易支持',
      transactionSupportTitle: '交易遇到问题？',
      transactionSupportDesc: 'ShieldMyAss 使用 ChangeNOW 作为流动性合作方，所有兑换均由 ChangeNOW 运营。有关交易的任何问题，请直接联系 ChangeNOW 客服，并提供状态页面显示的完整交易 ID（TXID）。',
      transactionSupportCta: '联系 ChangeNOW 客服',
    },
    coins: {
      eyebrow: '资产',
      title: '900+ 币种，30+ 网络。',
      lead: '从比特币到代币化黄金。下方实时列表直接来自我们的流动性合作方。',
      spotlightEyebrow: '焦点',
      spotlightTitle: '精选资产',
      catalogueEyebrow: '目录',
      catalogueTitle: '完整支持列表',
      allChips: '全部',
      searchPlaceholder: '搜索币种或网络...',
      showingFirst: '显示前 300 条，共 {total} 条。请缩小范围查看更多。',
      noMatch: '没有匹配“{query}”的币种。',
    },
    notFound: {
      eyebrow: '信号丢失',
      title: '脱离网络。',
      desc: '此页面不存在。好消息：兑换组件只需一键即达。',
      backToSwap: '回到兑换',
      browseCoins: '浏览币种',
    },
    exchangePair: {
      eyebrow: '实时汇率 · 无 KYC',
      aboutEyebrow: '关于此兑换对',
      aboutTitle: '关于 {from} / {to} 兑换对',
      aboutBody:
        '此页面是 ShieldMyAss 上用 {fromName} 兑换 {toName} 的专属路线。上方组件已预配置发送 {from}、接收 {to}，你可直接粘贴 {to} 地址并发送 {from}，无需改动。',
      beforeTitle: '发送之前',
      beforeDesc: '务必核对你的接收地址处于正确网络，且发送金额不少于组件显示的最低额。',
      moreEyebrow: '更多路线',
      moreTitle: '其他热门兑换对',
      faqEyebrow: '问答',
      faqTitle: '快速解答',
    },
    privacy: {
      eyebrow: '法律',
      title: '隐私政策',
      lead: '简短、通俗。最后更新于 {date}。',
      calloutTitle: '简版摘要',
      calloutText: '我们不索要身份、不在全网追踪你、不出售数据。我们处理的唯一个人数据是你为交易提供的钱包地址，交易完成即遗忘。',
      sections: [
        { h: '1. 我们是谁', p: ['{SITE}（“我们”）运营一个非托管加密货币兑换服务，网址 {DOMAIN}。ChangeNOW 是我们的流动性合作方，并负责运营所有兑换。'] },
        { h: '2. 我们收集的数据', p: [], ul: ['<strong>接收地址。</strong>你为交易输入的目标钱包地址。', '<strong>交易参数。</strong>执行并追踪兑换所需的兑换对、金额及交易 ID。', '<strong>技术日志。</strong>为防滥用与争议解决短期保留的 IP、UA 与时间戳。', '<strong>我们不收集：</strong>姓名、邮箱、电话、证件、银行卡或任何 KYC/AML 数据。'] },
        { h: '3. 为何处理', p: ['我们处理上述数据仅为执行你请求的兑换、防止欺诈与滥用、在适用情形下遵守合法请求，并就具体交易解决争议。'] },
        { h: '4. 保留时长', p: ['交易记录（兑换对、金额、地址、交易 ID）在兑换期间及之后一段用于支持与争议解决的有限窗口内保留。技术日志按短周期轮转。我们不维护与身份绑定的长期档案。'] },
        { h: '5. Cookie', p: ['{SITE} 不使用追踪 Cookie。站点所用存储（如保存币种列表滚动位置）均为严格功能性第一方存储，浏览器关闭即清除。'] },
        { h: '6. 第三方', p: ['所有兑换均由流动性合作方 ChangeNOW 执行并运营。发起交易时，执行所需参数会与 ChangeNOW 共享。其政策见 changenow.io/privacy-policy。'] },
        { h: '7. 你的权利', p: ['视司法辖区而定，你可能拥有访问、更正或删除个人数据的权利。由于我们不收集身份级数据，这些权利通常仅适用于与特定地址关联的交易记录。请联系我们行使权利。'] },
        { h: '8. 安全', p: ['{SITE} 非托管：我们绝不持有用户资金。为每笔交易生成的存款地址由流动性合作方控制，仅用于执行该交易。我们全站使用 HTTPS 并定期轮换基础设施凭证。'] },
        { h: '9. 政策变更', p: ['若我们改变收集内容或目的，将更新此页面并更新“最后更新”日期。我们绝不在未于此明确披露的情况下，追溯扩展至身份数据收集。'] },
        { h: '10. 联系', p: ['隐私问题？请邮件联系我们。'] },
      ],
    },
    terms: {
      eyebrow: '法律',
      title: '服务条款',
      lead: '最后更新于 {date}。',
      calloutTitle: '通俗摘要',
      calloutText: '你使用 {SITE} 兑换加密货币。我们提供路由，网络提供执行。你对输入的地址与金额负责。加密货币波动且不可逆——只兑换你能承受损失的部分。',
      sections: [
        { h: '1. 接受条款', p: ['访问 {DOMAIN} 即表示你同意本条款。如不同意，请勿使用本服务。'] },
        { h: '2. 服务', p: ['{SITE} 提供非托管兑换界面，并显示实时汇率和交易状态。ChangeNOW 是我们的流动性合作方，负责运营所有兑换。我们不托管资金、不持有余额，也不运营订单簿。'] },
        { h: '3. 资格', p: ['你须在你所在司法辖区达到法定年龄，且不得位于受限地区。你有责任遵守所在辖区的法律，包括对加密货币交易的限制。'] },
        { h: '4. 你的责任', p: [], ul: ['你必须为目标网络提供有效的接收地址。错误地址可能导致永久损失。', '你必须向存款地址发送正确资产。错误资产可能无法追回。', '你必须至少发送组件显示的网络最低额。更小额可能无法处理。', '你独自承担交易所产生的任何税务义务。'] },
        { h: '5. 汇率与费用', p: ['汇率在交易创建前为指示性，可能在你查看组件与存款确认之间变动。微小点差由流动性合作方嵌入汇率；{SITE} 不加收服务费。网络最低额实时显示。'] },
        { h: '6. 交易终局性', p: ['一旦存款在其网络被接收并确认，即执行兑换并将出账广播至你的接收地址。区块链上的交易通常不可逆。若兑换在网络层面失败，入账金额由合作方退回原地址。'] },
        { h: '7. 无担保', p: ['本服务“按现状”提供，不附任何担保。我们不保证不间断可用、特定汇率或在特定时限内完成兑换，因这些取决于我们无法控制的第三方网络。'] },
        { h: '8. 责任限制', p: ['在法律允许的最大范围内，{SITE} 对间接、附带或后果性损害，或因用户错误（包括错误地址或错误资产存款）造成的损失不承担责任。我们对任何索赔的累计责任以我们就该特定交易赚取的点差为限。'] },
        { h: '9. 禁止用途', p: ['你不得将 {SITE} 用于洗钱、恐怖融资、规避制裁或任何违法活动。在有理由相信与此类活动相关时，我们可拒绝或撤销交易。'] },
        { h: '10. 条款变更', p: ['我们可能不时更新本条款。重大变更将通过更新“最后更新”日期体现。变更后继续使用即视为接受。'] },
        { h: '11. 联系', p: ['对条款有疑问？请邮件联系我们。'] },
      ],
    },
  },
  faqs: [
    { q: 'ShieldMyAss 真的无 KYC 吗？', a: '是的。我们从不索要你的身份文件、邮箱或电话。ShieldMyAss 使用 ChangeNOW 作为流动性合作方，所有兑换均由 ChangeNOW 运营。标准金额无需身份核验。你的接收地址是我们唯一需要的信息。' },
    { q: '兑换需要多久？', a: '多数兑换在 5–30 分钟内完成。确切时间取决于你发送与接收的网络。例如比特币确认慢于 Solana 或 TRON。每个阶段——存款、确认、兑换、发送——都可在状态页实时查看。' },
    { q: '交易遇到问题时该怎么办？', a: 'ShieldMyAss 的所有兑换均由 ChangeNOW 运营。请访问 changenow.com/contact 直接联系 ChangeNOW 客服，并提供状态页面显示的完整交易 ID（TXID），方便客服查询兑换详情和最新状态。' },
    { q: '费用是多少？', a: '所见即所得。ShieldMyAss 在网络汇率之上加收 0%；合作流动性方在报价中嵌入微小点差（通常 0.25%–0.9%）。无隐藏服务费、无网络附加费、无订阅。' },
    { q: '你们托管我的资金吗？', a: '不。ShieldMyAss 非托管。你将币种发送至为该交易生成的一次性存款地址，网络兑换，出账直接发送到你的钱包。我们从不代你持有余额。' },
    { q: '如果我发错了币怎么办？', a: '务必核对存款地址与你选择的币种及网络一致。向存款地址发送错误资产可能导致永久损失。若出错，请立即访问 changenow.com/contact 联系 ChangeNOW 客服，并提供交易 ID——追回有时可行但不保证。' },
    { q: '有最低或最高交易额吗？', a: '有——每个兑换对都有网络最低额（通常等值数美元），在组件中实时可见。无硬性最高额，但超大额交易可能拆分至多个流动性来源以避免冲击市场。' },
    { q: '支持哪些加密货币？', a: '30+ 区块链上超过 900 种币，包括比特币、以太坊、Solana、门罗币、莱特币、BNB、Tether（USDT）、USD Coin（USDC）、Tether Gold（XAUT），以及数百种 ERC-20、BEP-20 与 SPL 代币。完整列表见“支持的币种”页。' },
    { q: '我能退款吗？', a: '若兑换在网络侧失败，出账金额会自动退回你的来源地址。若你输入了错误的接收地址，请访问 changenow.com/contact 联系 ChangeNOW 客服并提供交易 ID——能否追回取决于出账是否已广播。' },
  ],
  featuredBlurbs: {
    btc: '最初的储值型加密货币，也是 ShieldMyAss 上流动性最强的兑换对。',
    eth: '驱动 DeFi、NFT 及大多数代币兑换的可编程货币。',
    sol: '以快速终局性和低手续费著称的高吞吐 L1。',
    xmr: '隐私优先的加密货币，强制使用环签名混淆。',
    ltc: '比特币的白银——自 2011 年起快速确认与广泛钱包支持。',
    bnb: 'BNB Chain 生态的原生资产与顶级交易所代币。',
    usdt_trx: '采用最广的美元稳定币，在 TRON 网络上转移成本低廉。',
    usdc_eth: '由 Circle 在以太坊上发行的全额储备美元稳定币。',
    xaut: '一盎司实物黄金的代币化形式，链上可赎回。',
  },
};

export default zh;
